import cn from 'classnames';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import { useNotifications } from '#global/context/notifications/useNotifications.tsx';

type Props = {
  className?: string;
};

export function Notifications({ className }: Props) {
  const { notifications } = useNotifications();

  if (!notifications.length) return null;

  return (
    <Spacer className={cn(className)} direction="vertical">
      {notifications.map((n) => {
        return (
          <Banner key={n.id} variant={n.type}>
            {n.children}
          </Banner>
        );
      })}
    </Spacer>
  );
}
